// utils/profileUpdater.ts
import { ArconnectSigner } from "@ar.io/sdk/web";
import { generateProfilePageHTML } from './profilePageTemplate';
import { ARWEAVE_APP_NAME } from './constants';

export async function updateAmPassportProfile(params: {
  userData: any;
  currentPrimaryName?: string | null;
  currentAvatar?: string | null;
  levelTitle?: string;
  level?: number;
  userAntProcessId: string;
}): Promise<{ success: boolean; message: string; txId?: string }> {
  const { userData, currentPrimaryName, currentAvatar, levelTitle, level, userAntProcessId } = params;
  
  try {
    if (!window.arweaveWallet) {
      throw new Error("Wallet not connected");
    }
    
    // Generate profile HTML with REAL data
    const profileHTML = generateProfilePageHTML({
      userId: userData.userId,
      processId: userData.processId,
      points: userData.points,
      currentPrimaryName: currentPrimaryName || undefined,
      avatarUrl: currentAvatar || undefined,
      xId: userData.xId !== "Not linked" ? userData.xId : undefined,
      githubId: userData.githubId !== "Not linked" ? userData.githubId : undefined,
      levelTitle: levelTitle || 'Digital Wanderer',
      level: level || 0,
      pointsBreakdown: userData.pointsStats,
      xPostingsCount: userData.xPostingsCount,
      joinDate: userData.joinDate,
      githubInteractionsCount: userData.githubInteractionsCount
    });
    
    // Upload to Arweave
    const signedItem = await window.arweaveWallet.signDataItem({
      data: new TextEncoder().encode(profileHTML),
      tags: [
        { name: "Content-Type", value: "text/html" },
        { name: "App-Name", value: ARWEAVE_APP_NAME },
        { name: "Type", value: "ampassport-profile-update" },
        { name: "User-ID", value: userData.userId },
        { name: "Process-ID", value: userData.processId },
        { name: "Timestamp", value: Date.now().toString() }
      ],
    });
    
    const uploadRes = await fetch("https://up.arweave.net/tx", {
      method: "POST",
      headers: { "Content-Type": "application/octet-stream" },
      body: signedItem,
    });
    
    if (!uploadRes.ok) {
      throw new Error(`Upload failed: ${uploadRes.statusText}`);
    }
    
    const { id: txId } = await uploadRes.json();
    
    // Import ANT from SDK
    const { ANT } = await import("@ar.io/sdk/web");
    const ant = ANT.init({ 
      signer: new ArconnectSigner(window.arweaveWallet),
      processId: userAntProcessId
    });
    
    // Update the undername to point to NEW transaction
    await ant.setUndernameRecord({
      undername: "amprofile", // FIXED: was "amprofile"
      transactionId: txId,
      ttlSeconds: 900 // 24 hours
    });
    
    return {
      success: true,
      message: "Profile updated successfully! Changes will be visible in a few moments.",
      txId
    };
    
  } catch (error: any) {
    console.error("Failed to update amPassport profile:", error);
    return {
      success: false,
      message: error.message || "Failed to update profile"
    };
  }
}